



<div class="full-height border-gray border-radius-small background-white">
    
    <div 
        class="padding-none"
        #cardHeader
    >

        
        <div *ngIf="showHeaderObs | async" class="display-block full-width border-primary-bottom">
            
            <h4 *ngIf="!(showCollapsedModeSubject | async)" 
                class="mat-headline-4 padding-standard" 
            >
                <span>{{gridTitle | translate}}</span>
            </h4>
            <div    
                class="full-width gap-standard flex--align-center padding-standard"
                [ngClass]="{
                    'flex-row':!(showCollapsedModeSubject | async),
                    'flex-column':showCollapsedModeSubject | async,
                    'flex--justify-between':!(showCollapsedModeSubject | async),
                    'background-lightgray':showCollapsedModeSubject | async
                }"
            >
                
                <ss-search class="display-block full-width" *ngIf="showSearchObs | async"></ss-search>
                <ng-container *ngTemplateOutlet="toolbarTemplateSubject | async"></ng-container>        
                
            </div>
        </div>
    
    </div>

    <div class="grid-card-content full-width padding-none">

        <div class="full-height position-relative">
            <ss-core-loader-outlet [keys]="['grid.load']" class="full-height"></ss-core-loader-outlet>
    
            <ng-container *ngIf="showCollapsedModeSubject | async;else standardMode">
                <div  
                    fixedScroll 
                    [otherElements]="[header]"
                    class="display-block full-width  background-lightgray padding-standard"
                    #scroller
                >

                    <div class="warn-text padding-standard mat-headline-6" *ngIf="showNoDataObs | async;else scrollerData">

                        {{'ss-general.no-data' | translate}}

                    </div>

                    <ng-template #scrollerData>
                        
                        <div    *ngFor="let element of displayedDataSubject | async;let idx = index"
                                class="background-white flex-row flex--align-center border-radius-small border-gray flex--justify-between "
                                (click)="emitRowClicked(element,titleColumn)" 
                                [ngClass]="{ 'margin-standard-top':!!idx }" 
                        >

                            <div class="flex-column gap-none flex-1 full-width" >
                                
                                <div 
                                    class="flex-row gap-none full-width  padding-standard padding-right-none border-radius-small flex--justify-between position-relative" 
                                    [ngClass]="{
                                        'accent-background-A200-transparent': element.__pageIdx == -1
                                    }"
                                >
                                    
                                    <ss-cell 
                                        class="mat-headline-6 light-bold margin-none display-block full-width wrap-break-word primary-text-700-darkened"
                                        style="max-width: calc(100% - 9rem);" 
                                        [value]="getCellDisplay(element,titleDataFieldObs | async) | async | translate"
                                        [column]="titleColumnObs | async"
                                    ></ss-cell>

                                    <div *ngIf="actionsTemplateSubject | async" class="position-top-right-smaller">
                                        <ng-container *ngTemplateOutlet="actionsTemplateSubject | async;context:{element:element}" ></ng-container>
                                    </div>
                                    

                                </div>

                                <div class="divider"></div>
                                <ng-container *ngIf="showCollapsedColumnsObs | async">

                                    <div 
                                        *ngIf="titleColumnObs | async as titleCol"
                                        class="flex-row column-gap-standard full-width padding-standard flex-wrap row-gap-none" 
                                        (click)="emitRowClicked(element,titleColumn)"
                                        [customizeRow]="customizeRow"
                                        [customizeRowData]="element"
                                    >
                                        <ng-container *ngFor="let col of columnsObs | async">

                                            <div *ngIf="col.type!=='actions' && !col.title" class="flex-row gap-none">
                                                <ng-container *ngIf="(cellTemplatesSubject | async)?.[col.dataField];else defaultCell">
                                                    
                                                    <ng-container   *ngTemplateOutlet="(cellTemplatesSubject | async)[col.dataField];
                                                                    context: { element: element }"
                                                    ></ng-container>
                                                    
                                                </ng-container>

                                                <ng-template #defaultCell>
                                                    <div    *ngIf="getCellDisplay(element,col.dataField)  | async as display" 
                                                            class="flex-row gap-small mat-body-1 flex--align-center mat-mdc-card-subtitle padding-small-block"
                                                    >
                                                        <mat-icon class="data-grid-small-icon" *ngIf="col.icon" [color]="getColor(col,element)">{{getIcon(col,element)}}</mat-icon>
                                                        <ss-cell 
                                                            [class]="'mat-body-1 mat-mdc-card-subtitle display-block ' +getCollapsedColorClass(col,element)"  
                                                            [value]="getCellDisplay(element,col.dataField) | async | translate"
                                                            [column]="col"
                                                        ></ss-cell>
                                                    </div>
                                                </ng-template>
                                                
                                            
                                            </div>
                                        </ng-container>

                                    </div>
                                </ng-container>

                            </div>

                        </div>
                    </ng-template>
                </div>
            </ng-container>
            <ng-template #standardMode>
            <div class="padding-standard-bottom" fixedScroll [otherElements]="[header]" #scroller>
                <table  *ngIf="columnsObs | async" 
                        mat-table  
                        color="primary" 
                        [dataSource]="displayedDataSubject | async" 
                        [multiTemplateDataRows]="true" 
                        
                >
    
                        
                    <ng-container *ngFor="let col of columnsObs | async" [matColumnDef]="col.dataField" [sticky]="col.sticky" [stickyEnd]="col.stickyEnd">
                        <th mat-header-cell    *matHeaderCellDef class="light-bold mat-body-1"> {{col.caption | translate}}</th >
                        
                        <td  mat-cell 
                            (click)="emitRowClicked(element,col)"
                            *matCellDef="let element" 
                            [ngClass]="{'data-cell':col.type!=='actions','action-cell':col.type==='actions'}"
                        >   
    
                            <ng-container *ngIf="col.type==='actions';else showCell">
                                <ng-container *ngTemplateOutlet="actionsTemplateSubject | async;context:{element:element}" ></ng-container>
                            </ng-container>
    
                            <ng-template #showCell>
                                
                                <ss-cell 
                                    class="mat-body-1"
                                    [column]="col"        
                                    [value]="getCellDisplay(element,col.dataField) | async | translate"
                                ></ss-cell>

                            </ng-template>
    
                            <ng-container *ngIf="(cellTemplatesSubject | async)?.[col.dataField]">
                                <ng-container   *ngTemplateOutlet="(cellTemplatesSubject | async)[col.dataField];
                                                context: { element: element }"
                                ></ng-container>
                            </ng-container>
    
                    
                            
                        </td>
                    </ng-container>
                        
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsObs | async;sticky:true" ></tr>
    
                    <tr mat-row 
                        *matRowDef="let row; columns: displayedColumnsObs | async;" 
                        ssCoreLoaderOutlet 
                        [keys]="getRowLoaderKeys && getRowLoaderKeys(row)"
                        [ngClass]="{
                            'accent-background-A200-transparent': row.__pageIdx == -1
                        }"
                        [customizeRow]="customizeRow"
                        [customizeRowData]="row"
                    ></tr>
    
                </table>
            </div>
            </ng-template>

            
        </div>
   
    </div>
</div>